import React from 'react'
import { Link, useHistory  } from 'react-router-dom'

function WhyChose() {
  const navigate = useHistory ();
  return (
    <div className='mt-6 md:mt-10 flex flex-col lg:flex-row w-full sm:w-[96%] lg:w-[96%] xl:w-[85%] 2xl:w-[80%] h-auto m-auto'>
    <div className='flex flex-col p-10 sm:w-[80%] w-full lg:w-[50%] text-white '>
      <h1 className='text-xl sm:text-2xl md:text-3xl lg:text-3xl 2xl:text-3xl font-bold'>Why Should You Choose 
      Fit Streak?</h1>
      <h2 className='text-lg sm:text-xl md:text-2xl lg:text-xl 2xl:text-2xl mt-6 md:mt-8 lg:mt-4'>Personal Training</h2>
      <p className='text-md sm:text-lg md:text-lg lg:text-base xl:text-lg mt-4 md:mt-6 text-nav_option'>Achieve your fitness goals faster with personalized workout plans 
        tailored to your needs. At Fit Streak, our trainers focus on you to 
        ensure maximum results.</p>
      <h2 className='text-lg sm:text-xl md:text-2xl lg:text-xl 2xl:text-2xl mt-6 md:mt-8 lg:mt-4'>Expert Trainer</h2>
      <p className='text-md sm:text-lg md:text-lg lg:text-base xl:text-lg  mt-4 md:mt-6 text-nav_option'>
            Our certified trainers bring years of experience and expertise to 
        guide you every step of the way. They’re dedicated to helping 
        you stay motivated and achieve your best.
      </p>
      <h2 className='text-lg sm:text-xl md:text-2xl lg:text-xl 2xl:text-2xl mt-6 md:mt-8 lg:mt-4'>Flexible Time</h2>
      <p className='text-md sm:text-lg md:text-lg lg:text-base xl:text-lg  mt-4 md:mt-6 text-nav_option'>
            We understand busy schedules, so we offer flexible workout 
        timings to fit your lifestyle. Stay consistent with your fitness goals,
        no matter how packed your day is.
      </p>

      {/* <button className='py-2 px-6 bg-red xxs:text-sm text-center mt-6 w-max rounded-[5px] font-semibold '
      onClick={()=>{navigate.push("/joinNow") }}
      >
        Join Now
      </button> */}

    </div>

    <div className='flex hidden flex-col w-full   md:flex h-full lg:w-[50%]  lg:h-auto justify-center item-center '>
        <img
            src="/images/whyChose.png"
            alt="maleTrainer"
            className='w-[280px] sm:w-[450px] h-auto md:w-[700px] object-cover m-auto'
        />
    </div>
    <div className='flex block flex-col w-full md:hidden h-full justify-center '>
        <img
            src="/images/whyChose1.png"
            alt="maleTrainer"
            className='w-[90%] h-auto  object-cover m-auto'
        />
    </div>
    <div className='flex block flex-col w-full md:hidden mt-4 h-full justify-center '>
        <img
            src="/images/whyChose2.png"
            alt="maleTrainer"
            className='w-[90%] h-auto  object-cover m-auto'
        />
    </div>

  </div>
  )
}

export default WhyChose
